export interface Video {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  categoryId: string;
  categoryName: string;
  tags: string[];
  region: string;
  genre: string;
  year: number;
  duration: string;
  durationMinutes: number;
  plays: number;
  favorites: number;
  uploadTime: string;
  uploader: string;
  description: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  subCategories: string[];
}

export interface VideoFilters {
  region: string;
  genre: string;
  year: string;
  duration: string;
}

export type SortKey = "latest" | "plays" | "favorites";

export const defaultFilters: VideoFilters = {
  region: "全部",
  genre: "全部",
  year: "全部",
  duration: "全部",
};

export const sortOptions: { key: SortKey; label: string }[] = [
  { key: "latest", label: "最新上传" },
  { key: "plays", label: "播放最多" },
  { key: "favorites", label: "收藏最多" },
];